import { ErrorCode, FileRejection } from 'react-dropzone';
import { convertBytesToHumanReadableFormat } from '@/utils/helpers/fileSize.helpers';

export const getFileRejectionErrorMessages = (
  fileRejections: FileRejection[],
  { maxSize, maxFiles }: { maxSize?: number; maxFiles?: number },
): string[] => {
  const messages = fileRejections.flatMap((rejection) =>
    rejection.errors.map((error) => {
      if (error.code === ErrorCode.FileTooLarge && maxSize !== undefined) {
        return `File is larger than ${convertBytesToHumanReadableFormat(maxSize)}`;
      }
      if (error.code === ErrorCode.TooManyFiles && maxFiles !== undefined) {
        return `You can upload up to ${maxFiles} file${maxFiles === 1 ? '' : 's'}`;
      }
      return error.message;
    }),
  );

  return Array.from(new Set(messages));
};
